import { UserQuotaRulePeriodEnum } from '@jooxter/api';
import { JxtAlertTypeEnum } from '@jooxter/ui';
import { getRemainingTime } from './getRemainingTime';
import { IGetResourceQuotaAlertParams } from './types';

export interface IResourceQuotaAlert {
  type: JxtAlertTypeEnum;
  period: UserQuotaRulePeriodEnum;
  formattedRemainingTime?: string;
}

// The API only reports remainingTime (no total quota), so we can't tell "full/untouched"
// (Success) apart from "partially used" (Warning) as the old daily-quota alert did -
// collapsed to a 2-tier Error/Warning signal.
export const getResourceQuotaAlert = ({ quota, language }: IGetResourceQuotaAlertParams): IResourceQuotaAlert | null => {
  if (!quota || quota.remainingTime === undefined || quota.remainingTime === null || !quota.rulePeriod) {
    return null;
  }

  const { formatted: formattedRemainingTime } = getRemainingTime(String(quota.remainingTime * 60), language);
  const type = quota.remainingTime === 0 ? JxtAlertTypeEnum.Error : JxtAlertTypeEnum.Warning;

  return {
    type,
    period: quota.rulePeriod,
    formattedRemainingTime,
  };
};
